import React, { useMemo } from 'react';
import { isErrorFormGroup, isLabelProps, SEVERITY_MAPPING, useIds } from '../utils';
import { Label } from './Label';
import classNames from 'classnames';
import { HelpBlock } from './HelpBlock';

export const FormGroup = (props, ref) => {
    const {name, label, helpInput, helpBlock, severity, children, hideHelpBlock = false, role, tabIndex} = props;
    const ids = useIds(name, 'helpBlock', 'helpInput', 'id', 'ariaLabelledby');
    const isError = isErrorFormGroup(props);
    const isSuccess = severity === 'success';

    const rgaaLabel = useMemo(() => (
        { tagName: role ? 'p' : 'label', id: role ? ids.ariaLabelledby : undefined}
    ), [ids.ariaLabelledby, role])

    const labelElement = useMemo(() => {
        if(label) {
            if(isLabelProps(label)) {
                return <Label htmlFor={ids.id} {...label} {...rgaaLabel}/>;
            }
            return <Label htmlFor={ids.id} {...rgaaLabel}>{label}</Label>
        }
    }, [ids.id, label, rgaaLabel]);

    //Elément d'aide à la saisie
    const helpInputElement = useMemo(() => {
        if(helpInput) {
            if(typeof helpInput === 'string') {
                return <p className='help-input' id={ids.helpInput}>{helpInput}</p>
            }

            return <div className="help-input" id={ids.helpInput}>{helpInput}</div>
        }
    }, [helpInput, ids.helpInput]);

    return (
        <div
            ref={ref}
            className={classNames('form-group-version2', isSuccess && SEVERITY_MAPPING[severity], isError && severity && SEVERITY_MAPPING[severity])}
            role={role}
            aria-labelledby={classNames(role && ids.ariaLabelledby,role && helpInput && ids.helpInput,role && isError && ids.helpBlock) || undefined}
            tabIndex={tabIndex}>
            {(label || helpInput) && 
                <div className='wrapper-label'>
                    {labelElement}
                    {helpInputElement}
                </div>
            }
            {children}
            {isError && !hideHelpBlock && <HelpBlock id={ids.helpBlock}>{helpBlock}</HelpBlock>}
      </div>
    );
};